export default {
  'webhookMappingGenerationMapping.title': 'Mapeos Parámetros Webhook',

  'webhookMappingGenerationMapping.form.valueDestination': 'Destino Valor',
  'webhookMappingGenerationMapping.form.destinationForm': 'Formulario Destino',
  'webhookMappingGenerationMapping.form.destinationField': 'Campo Destino',
  'webhookMappingGenerationMapping.form.formFieldValueDestination': 'Destino Valor Campo',
  'webhookMappingGenerationMapping.form.destinationVariable': 'Variable Destino',
  'webhookMappingGenerationMapping.form.sourceParameterPosition': 'Ubicación de Envío',
  'webhookMappingGenerationMapping.form.sourceParameterCodification': 'Codificación Parámetro',

  'webhookMappingGenerationMapping.form.sourceTableParameterName': 'Nombre Parámetro Lista',
  'webhookMappingGenerationMapping.form.sourceParameterName': 'Nombre Parámetro',
  'webhookMappingGenerationMapping.form.destinationAttachmentFileName': 'Nombre del Adjunto',
  'webhookMappingGenerationMapping.form.destinationAttachmentContentType':
    'Tipo de Contenido del Adjunto',

  'webhookMappingGenerationMapping.form.select.FormField': 'Formulario / Campo',
  'webhookMappingGenerationMapping.form.select.Variable': 'Variable',
  'webhookMappingGenerationMapping.form.select.InstanceName': 'Nombre Solicitud',
  'webhookMappingGenerationMapping.form.select.OperationObservations':
    'Observaciones de la Operación',
  'webhookMappingGenerationMapping.form.select.OperationUserEmail':
    'Correo Usuario que realiza la Operación',
  'webhookMappingGenerationMapping.form.select.OperationIsApprovalOrReject':
    'Indicador Aprobación / Rechazo',

  'webhookMappingGenerationMapping.form.select.FieldValue': 'Valor a Mostrar',
  'webhookMappingGenerationMapping.form.select.FieldSearchValue': 'Valor de Búsqueda',

  'webhookMappingGenerationMapping.form.select.None': 'Sin Codificación',
  'webhookMappingGenerationMapping.form.select.ByteArray': 'Arreglo de Bytes',
  'webhookMappingGenerationMapping.form.select.Base64String': 'Cadena Base64',
  'webhookMappingGenerationMapping.form.select.ZipByteArray': 'Fichero Zip - Arreglo de Bytes',
  'webhookMappingGenerationMapping.form.select.ZipBase64String': 'Fichero Zip - Cadena Base64',
  'webhookMappingGenerationMapping.form.select.HttpBodyBinaryData':
    'Binario Codificado en Cuerpo de la Petición',

  'webhookMappingGenerationMapping.form.select.Header': 'Cabecera',
  'webhookMappingGenerationMapping.form.select.Url': 'Url',
  'webhookMappingGenerationMapping.form.select.FormData': 'Datos del formulario',
  'webhookMappingGenerationMapping.form.select.BodyJson': 'Cuerpo(JSON)',
  'webhookMappingGenerationMapping.form.select.XWwwFormUrlEncoded': 'Formulario Url Codificada',
  'webhookMappingGenerationMapping.form.select.Authorization': 'Autorización',
};
